import { SPONSORS } from "../../data/content";

const tileCls = (s) =>
  `group relative aspect-[16/9] w-[calc(50%-0.375rem)] md:w-[calc(25%-0.5625rem)] lg:w-[calc(20%-0.6rem)] flex flex-col items-center justify-center p-5 border border-neutral-800 transition-colors ${
    s.dark ? "bg-neutral-900" : "bg-white"
  } ${s.url ? "hover:border-red-600" : ""}`;

const SponsorTile = ({ s, i }) => {
  const inner = (
    <>
      <img
        src={s.logo}
        alt={`Logo ${s.name}`}
        loading="lazy"
        className="min-h-0 flex-1 max-w-full object-contain transition-transform duration-300 group-hover:scale-105"
      />
      {s.caption && (
        <span data-testid={`sponsor-caption-${i + 1}`} className="mt-2 shrink-0 mono-label text-[11px] font-bold uppercase tracking-wider text-red-600">
          {s.caption}
        </span>
      )}
      {s.url && (
        <span className="absolute left-2 bottom-1.5 mono-label text-[10px] text-neutral-500 opacity-0 group-hover:opacity-100 transition-opacity">
          {s.url.replace(/^https?:\/\/(www\.)?/, "").split("/")[0]}
        </span>
      )}
    </>
  );
  // Sponsor senza sito web: tile non cliccabile.
  if (!s.url) {
    return (
      <div data-testid={`sponsor-slot-${i + 1}`} title={s.name} aria-label={`Sponsor ${s.name}`} className={tileCls(s)}>
        {inner}
      </div>
    );
  }
  return (
    <a
      data-testid={`sponsor-slot-${i + 1}`}
      href={s.url}
      target="_blank"
      rel="noopener noreferrer sponsored"
      title={`Vai alla pagina di ${s.name}`}
      aria-label={`Pagina ufficiale ${s.name}`}
      className={tileCls(s)}
    >
      {inner}
    </a>
  );
};

export const SponsorGrid = () => (
  <div data-testid="sponsor-grid" className="flex flex-wrap justify-center gap-3">
    {SPONSORS.map((s, i) => <SponsorTile key={s.name} s={s} i={i} />)}
  </div>
);
